// 調整班表
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import '../../../scss/components/pages/edit_staff_shift.scss';
import {GetStoreRole} from '../../../const/constant';
import Calendar from '../../Calendar';
import AddStaffInAdjust from '../../AddStaffInAdjust';
import EditShiftBlockInAdjust from '../../EditShiftBlockInAdjust';
import Consolidation from '../../Consolidation';
import moment from 'moment';
//import DayPickerList from '../../DayPickerList';

import {
  getAdjustmentScheduleDetail,
  addStaffInAdjustShift,
  deleteStaffInAdjust,
  getAllStaff,
  InitAPIStatus,
  editWorkTime,
  editStaffWorkTimeInAdjust
} from '../../../store/action';
import swal from 'sweetalert2';

class AdjustStaffShiftDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarConfig: {
        defaultView: "agendaDay",
        //defaultView: "timelineDay",
        draggable: false,
        isEventClick: false,
        isDayClick: false,
        header: {
          left: 'title',
          center: '',
          right: 'agendaDay',
        },
        
      },
      resources: [],
      events: [],
      isAddStaffBlockOpen: false,
      isEditBlockOpen: false,
      editEvent: {},
      role: GetStoreRole(localStorage.getItem('current_store_id')) ,
      switchPanel: 1
    }
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleToggleAddStaffBlockOpen = this.handleToggleAddStaffBlockOpen.bind(this);
    this.handleDeleteStaffInAdjust = this.handleDeleteStaffInAdjust.bind(this);
    this.handleToggleEditShiftOpen = this.handleToggleEditShiftOpen.bind(this);
    this.handleEditshiftByEvent = this.handleEditshiftByEvent.bind(this);
    this.handleSaveEditWorkTime = this.handleSaveEditWorkTime.bind(this);
    this.onChangeStep = this.onChangeStep.bind(this);

  }

  componentDidMount() {
    if (this.state.role === '2' || this.state.role === '1' || this.state.role === '5' || this.state.role === '3') {
      let { day } = this.props.match.params;
      this.props.getAdjustmentScheduleDetail(day, false);
      this.props.getAllStaff();
    } else {
      this.props.history.push('/');
    }
  }

  componentWillReceiveProps(nextProsp) {
    const { resources, events } = nextProsp.adjustmentScheduleDetailState;

    var eventIndex = [];
    var resourceId = [];
    var formalResource = [];
    var unformalResource = [];
    //console.log(resources);

    let newResources = resources.map((item, index) => {


      if (item.title.indexOf('-') === -1 && item.id === -1) {
        eventIndex.push(index);
        resourceId.push(item.id);
        item.title = '本日活動';
        item.id = -1;
        item.eventColor = 'Plum';
        //item.eventBackgroundColor = 'Plum';
        //item.background = 'Plum';
      }else{
        item.title = item.title.split('-')[0];
        console.log(item.title)

        item.textColor = 'black';
        if (item.jobTypeId === 2) {
          item.eventColor = '#FFD966';
        } else if (item.jobTypeId === 3) {
          item.eventColor = '#EA9999';
        } else if (item.jobTypeId === 7 || item.jobTypeId === 4 || item.jobTypeId === 5 || item.jobTypeId === 6 || item.jobTypeId === 21) {
          item.eventColor = '#F4CCCC';
        } else if (item.jobTypeId === 12 || item.jobTypeId === 13 || item.jobTypeId === 14 || item.jobTypeId === 16) {
          item.eventColor = '#D9EAD3';
        } else if (item.jobTypeId === 8) {
          item.eventColor = '#6FA8DC';
        } else if (item.jobTypeId === 9 || item.jobTypeId === 10) {
          item.eventColor = '#CFE2F3';
        } else if (item.jobTypeId === 11) {
          item.eventColor = '#B6D7A8';
        } else if (item.jobTypeId === 15 || item.jobTypeId === 17 || item.jobTypeId === 18 || item.jobTypeId === 19) {
          item.eventColor = '#FFF2CC';
        }
      }
      if (item.title.indexOf('兼職') !== -1) {
        unformalResource.push(item);
      }else{
        formalResource.push(item);
      }

      return item;
    });



    if (eventIndex.length > 0) {
      for (var j = eventIndex.length - 1; j >= 0; j--) {        
        var b = newResources[eventIndex[j]];
        newResources[eventIndex[j]] = newResources[j];
        newResources[j] = b;
      }
    }

    let orderedResource = formalResource.concat(unformalResource);
    eventIndex = [];
    for (var l = orderedResource.length - 1; l >= 0; l--) {        
      if (orderedResource[l].title.indexOf('-') === -1) {
        eventIndex.push(l)
      }
    } 

    if (eventIndex.length > 0) {
      for (var k = eventIndex.length - 1; k >= 0; k--) {        
        var bb = orderedResource[eventIndex[k]];
        orderedResource[eventIndex[k]] = orderedResource[k];
        orderedResource[k] = bb;
      }
    }
    console.log(events)

    let newEvents = events.map((item, index) => {
      if (resourceId.indexOf(item.resourceId) !== -1 && item.title.indexOf('-') === -1) {
        item.resourceId = -1;
      }
      return item;

    });
    var realEvent =[];
    var restEvent =[];
    var inEvent =[];
    var outEvent =[];
    var barEvent =[];
    var supportEvent =[];

    newEvents.forEach(function(item){
      if (item.title.indexOf('09') !== -1) {
        realEvent.push(item);
      }else{
        restEvent.push(item);
      }
    });

    realEvent.forEach(function(item){
      if (item.title.indexOf('內場') !== -1) {
        inEvent.push(item);
      }else
      if (item.title.indexOf('外場') !== -1) {
        outEvent.push(item);
      }else
      if (item.title.indexOf('吧檯') !== -1) {
        barEvent.push(item);
      }else{
        supportEvent.push(item)
      }
    });

    var allEvent = inEvent.concat(outEvent).concat(barEvent).concat(supportEvent).concat(restEvent)

    this.setState({
      resources: orderedResource,
      events: allEvent
    });
    if (nextProsp.SendAPIState === 14 || nextProsp.SendAPIState === 15) {
      swal({
        type: 'warning',
        title: "該事件已簽核或有假單、加班單，無法編輯或刪除",
        showCloseButton: true,
        heightAuto: false,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: '確定',
      }).then((result) => {
        this.props.InitAPIStatus();
      })
    }
  }

  handleDayClick(date) {
    // if (this.state.role === '2' || this.state.role === '1' || this.state.role === '5' || this.state.role === '3') {
    //   this.props.history.push(`/adjustStaffShiftDetail/${date}`);
    // }
    
  }

  handleToggleAddStaffBlockOpen() {
    this.setState({
      isAddStaffBlockOpen: !this.state.isAddStaffBlockOpen
    });
  }

  handleDeleteStaffInAdjust(eventObj) {
    let { day } = this.props.match.params;
    this.props.deleteStaffInAdjust(eventObj.id, () => {this.props.getAdjustmentScheduleDetail(day, false)});
  }

  handleDaySelect(event) {
  }

  handleToggleEditShiftOpen() {
    this.setState({
      isEditBlockOpen: !this.state.isEditBlockOpen
    });
  }

  handleEditshiftByEvent(event) {
    this.setState({
      editEvent: event,
      isEditBlockOpen: true
    });
  }

  handleSaveEditWorkTime(targetevent) {
    let { day } = this.props.match.params;
    this.props.editWorkTime(targetevent, () => {this.props.getAdjustmentScheduleDetail(day, false)});
  }

  onChangeStep(step) {
    if(this.state.step === step) return;
    this.setState({
      switchPanel: step
    })
  }

  render() {
    let { day } = this.props.match.params;
    let events = [...this.state.events];
    let resources = [...this.state.resources];

    events = events.sort((a, b) => { const aHasKeyword = a.title.includes('休假') || a.title.includes('例假'); const bHasKeyword = b.title.includes('休假') || b.title.includes('例假'); if (aHasKeyword && !bHasKeyword) { return 1; } else if (!aHasKeyword && bHasKeyword) { return -1; } else { return 0; } });
    // let eventStartTime = moment(localStorage.getItem("startAt"), "YYYY-MM-DD");
    // let eventEndTime = moment(localStorage.getItem("endAt"), "YYYY-MM-DD");
    // let optionList = [];
    // let days = eventEndTime.diff(eventStartTime,'days') + 1
    // for (var i = 0; i < days; i++) {
    //   optionList.push(moment(eventStartTime, "YYYY-MM-DD").add(i,'days').format("YYYY-MM-DD").toString()) 
    // }
    //<DayPickerList datelist={optionList}/>
    var sortedResourceIds = events.map(event => event.resourceId); resources.sort((a, b) => { return sortedResourceIds.indexOf(a.id) - sortedResourceIds.indexOf(b.id); });
    resources.forEach(item => {
      if(item.title.indexOf('休假') !== -1)
        item.eventColor = 'Gold';
      else if (item.title.indexOf('例假') !== -1)
        item.eventColor = 'FireBrick';
      else if (item.title.indexOf('國定假日排假') !== -1)
        item.eventColor = 'IndianRed';

    });
    return (
      <div className="p-editShift">
        <div className="u-tag_group">
          <div className={this.state.switchPanel === 1 ? 'tag active' : 'tag'} onClick={()=>{this.onChangeStep(1)}}>調整班表</div>
          <div className={this.state.switchPanel === 2 ? 'tag active' : 'tag'} onClick={()=>{this.onChangeStep(2)}}>彙整表</div>
        </div>
        <div className="u-block overflow-x">
          <div style={{ display: this.state.switchPanel === 2 ? 'block' : 'none'}}>
            <div className="u-title">預期彙整人數表</div>
            <Consolidation date={day}/>
          </div>

          <div style={{ display: this.state.switchPanel === 1 ? 'block' : 'none'}}>
            <div className="u-title m-t-16">工作人員調整班表</div>
            <div className="u-notice">調整班別：請在工作條上連點兩下。
            <div className="change-day-div">             

              <button type="button" className="fc-promptResource-button fc-button fc-state-default fc-corner-left fc-corner-right" onClick={
                  (event) => { 
                    var tommorrow = moment(day, "YYYY-MM-DD").add(-1,'days').format("YYYY-MM-DD").toString();
                  this.props.history.push(`/adjustStaffShiftDetail/` + tommorrow);
                  window.location.assign("/adjustStaffShiftDetail/"+tommorrow);
                }
              }>
                前一天
              </button>
              <button type="button" className="fc-promptResource-button fc-button fc-state-default fc-corner-left fc-corner-right" onClick={
                  (event) => { 
                    var tommorrow = moment(day, "YYYY-MM-DD").add(1,'days').format("YYYY-MM-DD").toString();
                  this.props.history.push(`/adjustStaffShiftDetail/` + tommorrow);
                  window.location.assign("/adjustStaffShiftDetail/"+tommorrow);
                }
              }>
                下一天
              </button>
            </div>
            </div>
            <div className="u-notice">增加與縮短工時請將游標移至該工作人員工作條上，當游標變成←→時，即可拖曳修改該員工之工時。</div>


                        <div className="p-editShift__calendar">
              <Calendar {...this.state.calendarConfig}
                events={events}
                resources={resources}
                defaultDate={day}
                deleteResourceFunc={this.handleEditshiftByEvent}
                customerButtonFunc={this.handleToggleAddStaffBlockOpen}
                editWorkTimeFunc={this.props.editStaffWorkTimeInAdjust}
              />
            </div>
          </div>
        </div>

        <AddStaffInAdjust
          isVisible={this.state.isAddStaffBlockOpen}
          toggleOpen={this.handleToggleAddStaffBlockOpen}
          editDate={day}
          saveAddStaff={this.props.addStaffInAdjustShift}
          allStaff={this.props.allStaffListInAdjustState}
        />

        <EditShiftBlockInAdjust isVisible={this.state.isEditBlockOpen} 
          toggleOpen={this.handleToggleEditShiftOpen}
          event={this.state.editEvent}
          saveWorkTime={this.handleSaveEditWorkTime}
          deleteWorkTime={this.handleDeleteStaffInAdjust}
          jobType={this.state.editEvent.TypeId}
        />
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  SendAPIState: store.SendAPIStatusState,
  adjustmentScheduleDetailState: store.adjustmentScheduleDetailState,
  allStaffListInAdjustState: store.allStaffListInAdjustState
})

export default connect(mapStateToProps,{
  getAdjustmentScheduleDetail,
  addStaffInAdjustShift,
  getAllStaff,
  deleteStaffInAdjust,
  InitAPIStatus,
  editStaffWorkTimeInAdjust,
  editWorkTime
})(withRouter(AdjustStaffShiftDetail));